import { useGetUserByToken } from '@/helpers/useGetUserByToken'
import { TChat, TChatMessage, useGetMessagesByChatIdQuery } from '@/redux/services/webinarsApi'
import React, { useEffect, useState } from 'react'
import { Field, Message } from './Chat.components'
import { useChatScroll, useChatSocket } from './Chat.model'
import styles from './Chat.module.scss'

type TProps = {
    data: TChat
    messagesData?: TChatMessage[]
}

export const Chat: React.FC<TProps> = ({ data, messagesData }) => {
    const [messages, setMessages] = useState<TChatMessage[]>(messagesData ?? [])
    const { data: chatMessage } = useGetMessagesByChatIdQuery(data?.id)
    const isEmpty = messages.length === 0
    const user = useGetUserByToken()
    const listRef = useChatScroll<TChatMessage[], HTMLUListElement>(messages)

    const processNewMessage = (data: TChatMessage) => {
        setMessages((prevMessages: TChatMessage[]) => [...prevMessages, data])
    }
    const { sendMessage } = useChatSocket(processNewMessage)

    useEffect(() => {
        if (chatMessage) {
            setMessages([...chatMessage])
        }
    }, [chatMessage])

    const handleMessageSend = (text: string) => {
        const payload = {
            author: user?.id,
            text: text,
            chat: data.id
        }
        sendMessage(payload)
    }

    const renderList = () => {
        if (isEmpty) {
            return <div className={styles.empty}>Нет новых сообщений</div>
        }

        return (
            <ul
                ref={listRef}
                className={styles.list}
            >
                {messages.map(message => (
                    <li key={message.id}>
                        <Message
                            author={message.author.name}
                            text={message.text}
                            isUserMessage={message.author_id === user?.id}
                        />
                    </li>
                ))}
            </ul>
        )
    }

    return (
        <>
            <div className={styles.container}>
                {renderList()}
                <Field onMessageSend={handleMessageSend} />
            </div>
        </>
    )
}
